import { Schema, type } from "@colyseus/schema"

export class CustomsClass extends Schema {
  @type("string") cards: string
  @type("string") background: string

  constructor(cards = "default", background = "default") {
    super()

    this.cards = cards
    this.background = background
  }
}

export type Customs = InstanceType<typeof CustomsClass>
